import React, { Component } from 'react';
import { routerShape } from 'react-router';
import LazyHydrate from 'react-lazy-hydration';
import PropTypes from 'prop-types';
import each from 'lodash/each';
import get from 'lodash/get';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import preload from 'preload';
import DataProvider from 'api/data-provider';
import seoPreload, { seoDecorator } from 'api/seo';
// import dataCheck from 'api/data-check';
import { authConnect, UserProp } from 'auth';
import contentBlock, { blockPreloader } from 'containers/content-block';
import AdSense from 'components/adsense';
import Row, { Col } from 'components/row';
import Breadcrumbs from 'components/breadcrumbs';

import ClubInfo from './club-info';
import TopicInfo from '../../common/topic-info';
import ContextBlock from '../../context-block';
import { getRandRootIds/*, RootTopic*/ } from '../../forums/page-forum';
import AsideBlockList from '../../forums/aside-block-list';
import blocksConfig from '../../blocks/config';
import BlockWrapper from '../../blocks/block-wrapper';

import linksForum from 'src-sites/forum/links';
import config from 'src-sites/forum/const-config';

import translates from '../../forum-i18n';

import 'styles/forum/search/_page-search.scss';
import 'styles/forum/section-forum/_page-forum.scss';

const { limitCountPost } = config;

const bemClasses = new Bem('forum');
const bemClassesPostsBlock = new Bem('postsBlock');

@preload((routeProps) => {
  const { params, location } = routeProps;
  const { landing } = params;
  const { query = {} } = location;

  const postsQuery = {
    'topic-id': landing.entity_id,
    'order': [['post_time', 'asc']],
    count: true,
    limit: limitCountPost,
    offset: landing.offset
  };

  if (query.search) {
    postsQuery['search-text'] = query.search;
    postsQuery['highlight'] = query.search;
  }

  if (query.highlight) {
    postsQuery['highlight'] = query.highlight;
  }

  return {
    // Данные темы
    topics: [DataProvider.preload, {
      url: 'forum/topic',
      query: {
        'topic-id': landing.entity_id
      }
    }],
    // Данные объявлений
    preloadedAds: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        each(data.topics.data, val => (
          cfg.ads = [DataProvider.preload, {
            url: 'forum/ad',
            query: {
              'parent-tree-id': `${val.tree}-${val.forum_type}`,
              active: 1
            }
          }]
        ));
        return cfg;
      }
    },
    // Данные правил
    preloadedRulesList: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        each(data.topics.data, val => (
          cfg.rulesList = [DataProvider.preload, {
            url: 'forum/forum',
            query: {
              'tree-parent': val.tree
            }
          }]
        ));
        return cfg;
      }
    },
    // Данные клуба
    clubInfo: [DataProvider.preload, {
      url: 'forum/club',
      query: {
        'topic-id': landing.entity_id
      }
    }],
    // Данные постов
    preloadedPosts: [DataProvider.preload, {
      url: 'forum/post',
      query: postsQuery,
      queryJson: true
    }],
    // Helper data for data-provider posts query
    preloadedPostsQuery: [() => Promise.resolve(postsQuery)],
    // Данные голосовалок
    preloadedVoting: [DataProvider.preload, {
      url: 'forum/question',
      query: {
        'topic-id': landing.entity_id,
        date_off: true
      }
    }],
    // Данные блока новостройки
    preloadedNewbuildBlock: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        const lcId = get(data, 'topics.data[0].lc_id');
        if (lcId) {
          cfg.lcBlock = [DataProvider.preload, {
            url: 'forum/location/newbuild',
            query: { id: lcId }
          }];
        }
        return cfg;
      }
    },
    mainDeveloper: {
      $wait: ['preloadedNewbuildBlock'],
      $callback: (data) => {
        const cfg = {};
        const mainDeveloper = get(data, 'preloadedNewbuildBlock.lcBlock.data[0].salers[0].parent');
        if (mainDeveloper) {
          cfg.mainDeveloper = [DataProvider.preload, {
            url: 'domik/users/developer',
            query: {
              id: mainDeveloper
            },
            requestClientCache: 1
          }]
        }
        return cfg;
      }
    },
    // Данные о структуре ЖК из таблицы сроков сдачи
    preloadedLcStructure: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        const lcId = get(data, 'topics.data[0].lc_id');
        if (lcId) {
          cfg.lcStructure = [DataProvider.preload, {
            url: 'forum/investor-registry/lc-structure',
            query: {locationId: lcId}
          }];
        }
        return cfg;
      }
    },
    landingLc: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        const domik_land_tree = get(data, 'topics.data[0].domik_land_tree');
        if (domik_land_tree) {
          cfg.landingLc = [DataProvider.preload, {
            url: 'bild/complex-child-landings',
            query: {
              branch: domik_land_tree,
              entityNot: 'object'
            },
            cache: 60,
            requestClientCache: 1,
          }];
        }
        return cfg;
      }
    },
    // Данные карусели тегов
    preloadedTagsSlider: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        const topic = data.topics.data[0] || {};
        if (topic.tagsEnd && topic.tagsEnd.length) {
          cfg.tagSlider = [];
          each(topic.tagsEnd, (tag, index) => (
            cfg[`tagSlider${index}`] = [DataProvider.preload, {
              url: 'forum/tag-slider-ad',
              query: {
                tag: tag.link
              }
            }]
          ));
        }
        return cfg;
      }
    },
    // Данные рут форума
    rootForums: [DataProvider.preload, {
      url: 'forum/forum',
      query: {
        'root-forums': 1,
        'order-by': 'weight'
      }
    }],
    landing: [() => Promise.resolve({
      ...landing,
      postsCount: limitCountPost,
      query: landing.params,
      breadcrumbsPath: landing.breadcrumbs_path,
    }), {}],
    ...seoPreload({ entity: 'topicPage' }, ['landing', 'topics']),
    ...blockPreloader({
      project: 'forum',
      entity: 'topicPage'
    }, blocksConfig, ['topics'])
    // TODO продумать и переделать эту логику
    // Оно нужно для списков тем сбоку, и очень тормозит
    /*preloadedLastTopicList: {
      $wait: ['topics'],
      $callback: (data) => {
        const cfg = {};
        const forum_id = get(data, 'topics.data[0].forum_id');
        if (!forum_id) return cfg;
        cfg[forum_id] = [DataProvider.preload, {
          url: 'forum/topic-list',
          query: {
            'forum-id': forum_id,
            'order-by-desc': 'topic_last_post_time',
            count: true,
            limit: 15
          },
          cache: 5
        }]
        return cfg;
      }
    },
    preloadedOtherTopicList: {
      $wait: ['rootForums'],
      $callback: (data) => {
        const cfg = {};
        const rootForums = get(data, 'rootForums.data', []);
        if (!rootForums.length) return cfg;

        each(rootForums, (val, key) => {
          if (!val.id) return null;
          cfg[key] = [DataProvider.preload, {
            url: 'forum/topic-list',
            query: {
              'tree': val.id,
              'order-by-desc': 'topic_last_post_time',
              count: true,
              limit: 10
            },
            cache: 5
          }]
        })
        return cfg;
      }
    }*/
  };
})
@authConnect()
@seoDecorator({
  defaultTitle: 'Forum.domik.ua',
  advancedVars: {}
})
@I18nHoc(translates())
export default class ClubTopic extends Component {
  static propTypes = {
    className: PropTypes.string,
    params: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      page: PropTypes.string,
      post: PropTypes.string
    }),
    router: routerShape,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    checkPermission: PropTypes.func,

    // Preloaded data
    clubInfo: PropTypes.shape({}),
    topics: PropTypes.shape({}),
    preloadedPosts: PropTypes.shape({}),
    preloadedVoting: PropTypes.shape({}),
    preloadedAds: PropTypes.shape({}),
    preloadedRulesList: PropTypes.shape({}),
    preloadedNewbuildBlock: PropTypes.shape({}),
    mainDeveloper: PropTypes.shape({}),
    preloadedLcStructure: PropTypes.shape({}),
    landingLc: PropTypes.shape({}),
    preloadedTagsSlider: PropTypes.shape({}),
    rootForums: PropTypes.shape({}),
    preloadedLastTopicList: PropTypes.shape({}),
    preloadedOtherTopicList: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.getForumId = this.getForumId.bind(this);

    this.state = { forumId: null };
  }

  /**
   * Get forum id from TopicInfo.
   */
  getForumId(forumId) {
    this.setState({ forumId });
  }

  renderSearchContentBlock =(name)=> {
    return contentBlock(blocksConfig, name, this.props, { classNameWrapper: name, location: get(this, 'props.location') });
  }

  render() {
    const { i18n } = this;
    const {
      className, params = {}, clubInfo, topics, router, location,
      preloadedPosts, preloadedPostsQuery, preloadedVoting,
      preloadedAds = {}, preloadedRulesList = {},
      preloadedNewbuildBlock = {}, preloadedTagsSlider, preloadedLcStructure, landingLc, rootForums,
      preloadedLastTopicList, preloadedOtherTopicList, mainDeveloper
    } = this.props;
    const { landing } = params;
    const querySearch = get(location, 'query.search');
    // const rootForumData = get(rootForums, 'data');
    const topicTree = get(topics, 'data[0].tree');
    const dataObj = get(topics, 'data[0]') || {};
    if (!this.randRootIds) this.randRootIds = getRandRootIds.call(this, preloadedOtherTopicList);
    const currentTopicList = get(preloadedLastTopicList, `[${dataObj.forum_id}].data`);
    const parent_forum_title = get(dataObj, 'parent_forum_title');
    const parentForumUrl = get(dataObj, 'parent_forum_url');
    const forumParent = +get(dataObj, 'parent');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksForum.sectionForum,
        builderProps: { title: i18n('breadcrumbsMain') }
      }
    ];
    if (parentForumUrl && parent_forum_title && forumParent){
      dataBreadcrumbs.push({
        name: parent_forum_title,
        builder: linksForum.sectionForums,
        builderProps: {
          id: forumParent,
          forum_title: parent_forum_title,
          forumUrl: parentForumUrl
        }
      });
    }
    dataBreadcrumbs.push({
      name: dataObj.forum_title,
      builder: linksForum.sectionForums,
      builderProps: dataObj
    });
    dataBreadcrumbs.push({
      name: dataObj.topic_title,
      builder: linksForum.sectionTopic,
      builderProps: dataObj
    });
    if (querySearch) {
      dataBreadcrumbs.push({
        name: querySearch,
        builder: linksForum.sectionForums,
        builderProps: {
          builder: linksForum.sectionTopic,
          builderProps: dataObj
        }
      });
    }

    return (
      <>
        <Breadcrumbs
          {...bemClasses('breadcrumbs', 'top')}
          data={dataBreadcrumbs}
          noJson
        />
        <Row mtColumn mpColumn>
          <DataProvider
            url="forum/club"
            query={{ 'topic-id': params.id }}
            updateEvent="updateClubList"
            preloaded={clubInfo}
          >
            <ClubInfo
              router={router}
              params={params}
              showDesc={false}
              noHeaderTag
              noThemesList
            />
          </DataProvider>
          <DataProvider
            {...bemClassesPostsBlock({ extra: className })}
            url="forum/topic"
            updateEvent="updateTopic"
            query={{ 'topic-id': landing.entity_id }}
            preloaded={topics}
          >
            <TopicInfo
              router={router}
              params={params}
              auth={this.props.auth}
              actionDoLogin={this.props.actionDoLogin}
              checkPermission={this.props.checkPermission}
              getForumId={this.getForumId}
              preloadedAds={preloadedAds.ads}
              preloadedRulesList={preloadedRulesList.rulesList}
              preloadedVoting={preloadedVoting}
              preloadedPosts={preloadedPosts}
              postsQuery={preloadedPostsQuery}
              preloadedNewbuildBlock={get(preloadedNewbuildBlock, 'lcBlock.data[0]', [])}
              mainDeveloper={get(mainDeveloper, 'mainDeveloper.data[0]', [])}
              preloadedLcStructure={get(preloadedLcStructure, 'lcStructure.data', [])}
              landingLc={landingLc}
              preloadedTagsSlider={preloadedTagsSlider}
              search={querySearch}
              renderSearchContentBlock={this.renderSearchContentBlock}
            />
          </DataProvider>
          <Col {...bemClasses('col', 'aside')} mtColumn mpColumn mdCw={330} mdPl={30} allPr={0}>
            <ContextBlock block_number={1} forum_id={this.state.forumId} />
            {/*!!rootForumData && !!rootForumData.length &&
              <RootTopic
                router={router}
                data={rootForumData}
                topicTree={topicTree}
                searchPlaceholder={i18n('searchOnForumDomikUA')}
              />
            }
            <AsideBlockList
              topic={i18n('nowDiscussing')}
              router={router}
              topicList={currentTopicList}
              quantity={15}
              view="gray"
            />
            {!!this.randRootIds && !!this.randRootIds.length &&
              map(this.randRootIds, (it, key) => {
                const tree = get(it, 'data[0].tree', '');
                const treeArr = tree.split('.');
                const root = get(treeArr, '[0]');
                const rootIndex = findIndex(rootForumData, it => it.id === +root);

                return (
                  <AsideBlockList
                    key={key}
                    router={router}
                    topic={get(rootForumData, `[${rootIndex}].forum_title`) || i18n('nowDiscussing')}
                    topicList={get(it, 'data')}
                    quantity={10}
                    view="gray"
                  />
                );
              })
            */}
            {contentBlock(blocksConfig, 'rightColumn1', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn2', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn3', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn4', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn5', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn6', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn7', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn8', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn9', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blocksConfig, 'rightColumn10', this.props, { wrapper: BlockWrapper, withContainer: false })}
            <ContextBlock block_number={2} forum_id={this.state.forumId} />
          </Col>
        </Row>
        <AdSense />
        <LazyHydrate whenVisible>
          {contentBlock(blocksConfig, 'bottom1', this.props, { wrapper: BlockWrapper, withContainer: false })}
          {contentBlock(blocksConfig, 'bottom2', this.props, { wrapper: BlockWrapper, withContainer: false })}
        </LazyHydrate>
        <Breadcrumbs
          {...bemClasses('breadcrumbs')}
          data={dataBreadcrumbs}
        />
      </>
    );
  }
}
